import { useTranslation } from "react-i18next";
import type { MissionsCampaign } from "@/campaigns/modules/missions/types";
import { CampaignFinishedCard } from "@/components/campaign-card/campaign-finished-card";
import { CampaignJoinState } from "@/components/campaign-card/campaign-join-cta";
import { CampaignDockPanel } from "@/components/campaigns/campaign-shell/campaign-dock-panel";
import { FINISHED_DIM } from "@/components/campaigns/campaign-shell/campaign-view";
import { cn } from "@/lib/utils";
import { MissionLadder, MissionsCompletedCard } from "./missions-sections";

/**
 * Missions in the overlay's dock column: the detail view's sections at dock
 * density — how many steps are done, with the join state, then the whole
 * ladder: the step the player is on open with its reward, its round on a
 * repeatable step and its tasks' live progress; the done and locked ones
 * folded, each opening to its tasks. Once every step is done the completed
 * card says so on its own. Once the campaign is over, the detail view's
 * finished card leads and the steps grey out as history.
 */
export const MissionsDockPanel = ({
  missionsCampaign,
  joined,
}: {
  missionsCampaign: MissionsCampaign;
  joined: boolean;
}) => {
  const { t } = useTranslation();
  const finished = missionsCampaign.campaign.status === "FI";

  return (
    <CampaignDockPanel minimumBet={missionsCampaign.minimum_bet}>
      {finished && (
        <CampaignFinishedCard
          campaign={missionsCampaign.campaign}
          title={t("missions.finished")}
        />
      )}
      <div className={cn("flex flex-col gap-3", finished && FINISHED_DIM)}>
        <MissionsCompletedCard
          missionsCampaign={missionsCampaign}
          density="dock"
        >
          <CampaignJoinState
            campaign={missionsCampaign.campaign}
            joined={joined}
          />
        </MissionsCompletedCard>
        <MissionLadder missionsCampaign={missionsCampaign} density="dock" />
      </div>
    </CampaignDockPanel>
  );
};
